<template>
  <footer>
    <div class="footer_content">
      <ul class="footer_list footer_message">
        <li class="footer_title footer_company_name">株式会社futurelabo</li>
        <li><router-link tag="li" to="/contact"><a class="footer_button">&gt;&nbsp;お問い合わせはこちら</a></router-link></li>
        <li>office</li>
        <li class="footer_office">〒150-0002 東京都渋谷区渋谷3-5-16渋谷三丁目スクエアビル2F</li>
        <li class="footer_map"><a href="#" @click="clickSmoothScroll('about')"><span><img src="../assets/img/arrow_icon.svg" alt="矢印" class="arrowImg"></span>futurelaboとは</a></li>
        <li class="footer_map"><a href="#" @click="clickSmoothScroll('service')"><span><img src="../assets/img/arrow_icon.svg" alt="矢印" class="arrowImg"></span>サービス</a></li>
        <li class="footer_map"><a href="#" @click="clickSmoothScroll('client')"><span><img src="../assets/img/arrow_icon.svg" alt="矢印" class="arrowImg"></span>クライアント企業</a></li>
        <li class="footer_map"><a href="#" @click="clickSmoothScroll('career')"><span><img src="../assets/img/arrow_icon.svg" alt="矢印" class="arrowImg"></span>採用情報</a></li>
        <li class="footer_map"><a href="#" @click="clickSmoothScroll('company')"><span><img src="../assets/img/arrow_icon.svg" alt="矢印" class="arrowImg"></span>会社概要</a></li>
        <li class="footer_map"><a href="/#news"><span><img src="../assets/img/arrow_icon.svg" alt="矢印" class="arrowImg"></span>ニュース</a></li>
      </ul>
    <div class="footer_fb clearfix">
<iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FInternshipguide%2F&tabs=timeline&width=500&height=300&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=132536636956230" width="500" height="300" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
    </div>
    </div>
    <small>Copyright &copy; futurelabo, INC. All Rights Reserved.</small>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      msg: ''
    }
  },
  methods: {
    clickSmoothScroll (target) {
      event.preventDefault()
      if (document.querySelector('#' + target)) {
        this.$SmoothScroll(
          document.querySelector('#' + target),
          400,
          null,
          null,
          'y'
        )
      } else {
        location.href = '/#' + target
      }
    }
  }
}
</script>
<style>
  footer{
    background-color: #1f30aa;
    margin: 0;
    height:400px;
  }
  .footer_fb{
   float: right;
   position: relative;
   margin-top:-20px;
   height:300px;
  }
  footer small
  {
    color: #fff;
    clear: both;
    display: block;
    text-align: center;
  }
  .footer_content{
    width: 1080px;
    margin: 0 auto;
    padding: 0 0 50px 0;
  }
  ul.footer_list{
    display: inline-block;
    vertical-align: middle;
  }
  ul.footer_list li{
    color: #fff;
    font-size: 0.8em;
  }
  ul.footer_list li a{
    color: #ffffff;
  }
  ul.footer_list li.footer_title{
    font-size: 1.4em;
    font-weight: 700;
  }
  .footer_map{
    padding: 3px 0;
    font-size: 0.6em;
  }
  ul.footer_list li a.footer_button{
    color: #1f30aa;
    font-size: 1.2em;
  }
  ul.footer_list li.footer_office{
    padding-bottom: 20px;
  }
ul.footer_menu{
  margin-top: 40px;
}
  .clearfix:after {
    content: "";
    clear: both;
    display: block;
  }
  .footer_message li.footer_company_name{
    padding: 35px 0;
    font-size: 1.6em;
  }
  .footer_button{
    margin: 20px 0;
  }
.arrowImg{
  width: 10px;
}
ul.footer_message{
  width: 50%;
  margin-top: 0;
}
ul.footer_company{
  width: 34%;
  margin-top: -350px;
}
  ul.footer_facebook{
    width: 40%;
    margin-top: 50px;
  }
  @media screen and (max-width:1080px) {
    ul.footer_message{
      width: 40vw;
      padding-left: 5vw;
    }
    .footer_content{
      display: flex;
      justify-content: space-around;
      width: 100vw;
      max-width: 100%;
    }
    .footer_fb{
      margin: 0 auto;
    }
    .footer_fb iframe{
    margin-top: 35px;
      width: 50vw;
    }
  }
  @media screen and (max-width:867px) {
    ul.footer_message {
      display: none;
    }
    .footer_fb iframe{
      max-width: 500px;
      width: 90vw;
    }
    footer {
    height: 380px;
}
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue